
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.22 4.377a.833.833 0 01.07 1.176l-8.89 10a.833.833 0 01-1.245 0l-4.444-5a.833.833 0 011.245-1.107l3.822 4.299 8.266-9.3a.833.833 0 011.176-.068z","fill":"#008C89"}})])
          )
        }
      }
    